import { createI18n } from "vue-i18n";
import ja from "./locales/ja.js";

// サポートする言語一覧
const SUPPORTED_LOCALES = [
  "ja", "en", "zh", "ko", "es", "fr", "de", "pt", "vi", "th", "id",
];

// ブラウザの言語設定から初期ロケールを決定
function detectBrowserLocale() {
  const browserLang = navigator.language || navigator.userLanguage || "ja";
  const shortLang = browserLang.split("-")[0].toLowerCase();
  return SUPPORTED_LOCALES.includes(shortLang) ? shortLang : "ja";
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectBrowserLocale(),
  fallbackLocale: "ja",
  messages: {
    ja,
  },
});

// ロード済みロケールを追跡
const loadedLocales = new Set(["ja"]);

/**
 * 言語を動的にロードしてセット
 * @param {string} locale - 言語コード (e.g., "en", "zh")
 */
export async function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) {
    locale = "ja";
  }
  if (!loadedLocales.has(locale)) {
    try {
      const messages = await import(`./locales/${locale}.js`);
      i18n.global.setLocaleMessage(locale, messages.default);
      loadedLocales.add(locale);
    } catch (e) {
      console.warn(`Locale "${locale}" not found, falling back to "ja"`);
      locale = "ja";
    }
  }
  i18n.global.locale.value = locale;
}

export default i18n;
